<template>
  <v-layout>
    <div class="row messages">
      <div class="col col-md-3 col-3 p-0 h-100 border-right">
        <b-input-group
          size="md"
          class="py-3 px-4">
          <b-input-group-text
            slot="append"
            class="bg-white"
          >
            <strong><i class="icon ion-md-search" /></strong>
          </b-input-group-text>
          <b-form-input
            :value="filter.searchValue"
            class="border-right-0"
            placeholder="Search for patient name"
            @keyup.enter.native="onSearchText"
            @blur.native="onSearchText"
          />
        </b-input-group>
        <ul
          class="messagesContainer slimscroll m-0 p-0"
          id="patients">
          <li
            :class="`align-items-center d-flex p-3 patients ${
              selectedPatient && (selectedPatient.patient_id === patient.patient_id) ?
                'active' :
            ''}`"
            v-for="patient in patients"
            :key="patient.patient_id"
            @click="selectPatient(patient)"
          >
            <img
              :src="require(`@/assets/image/${
                patient && patient.gender === 'male' ?
                  'boy':
                  'girl'
              }.svg`)"
              width="35"
              height="35"
              :alt="patient.first_name"
              v-b-tooltip.hover
              :title="patient.first_name"
            >
            <div class="flex-grow-1 text-truncate">
              <div class="text-truncate d-flex">
                <div class="text-truncate flex-grow-1 font-weight-bold pr-2">
                  {{ patient.first_name | capitalizefirst }}
                  {{ patient.last_name | capitalizefirst }}
                </div>
                {{ getDateFromNow(patient.created_at) }}
              </div>
              <div class="text-truncate">{{ patient.description }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="col col-md-9 col-9 p-0 h-100">
        <v-message
          v-if="selectedPatient || patients[0]"
          :patient="selectedPatient ? selectedPatient : patients[0]" />
      </div>
    </div>
    <v-loader :isLoading="isPatientsLoading" />
  </v-layout>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import VLayout from '@/layouts/Default.vue';
import VMessage from '@/components/message/index.vue';
import infiniteScroller from '@/utils/infiniteScroller';
import VLoader from '@/components/loader/index.vue';

export default {
  name: 'Message',
  components: {
    VLayout,
    VMessage,
    VLoader
  },
  data() {
    return {
      filter: {
        pageNo: 1,
        limit: 20,
        searchValue: ''
      },
      moment,
      selectedPatient: null
    };
  },
  computed: {
    ...mapGetters({
      patients: 'message/getPatients',
      patientMessages: 'message/getPatientMessages',
      isPatientsLoading: 'message/getIsPatientListLoading',
      patientsTotalCount: 'message/getPatientsTotalCount',
      patientDataToMsg: 'patient/getPatientDataToMsg'
    })
  },
  watch: {
    filter: {
      handler: 'onFilterChanged',
    },
  },
  beforeMount() {
    if (this.patientDataToMsg.isSelectedPatient) {
      this.filter = {
         ...this.filter,
         searchValue: this.patientDataToMsg.mrId
       };
       this.$store.dispatch('patient/clearPatientMsgData');
    } else {
      this.filter = {
         ...this.filter,
         searchValue: undefined
       };
    }
  },
  mounted() {
    const element = document.getElementById('patients');
    if (element) {
      element.addEventListener('scroll', event =>
        infiniteScroller(
          event,
          () => {
            this.filter = { ...this.filter, ...{ pageNo: this.filter.pageNo + 1 } };
          },
          null,
          {
            percentage: 100,
            currentLength: this.patients.length,
            totalLength: this.patientsTotalCount
          }
        ));
    }
  },
  beforeDestroy() {
    const element = document.getElementById('patients');
    if (element) {
      element.removeEventListener('scroll', event => infiniteScroller(event));
    }
  },
  methods: {
    onFilterChanged(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.fetchPatients();
      }
    },
    fetchPatients() {
      this.$store.dispatch('message/fetchPatients', this.filter);
    },
    selectPatient(selectedPatient) {
      this.selectedPatient = selectedPatient;
      this.filter = { ...this.filter, ...{ pageNo: 1 } };
    },
    onSearchText(event) {
      this.filter = {
        ...this.filter,
        searchValue: event.target.value
      };
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>

